import { PENDING_INVITE_KEY } from '../context/BandContext';

// An invite token kept while the person signs in or creates an account. It's in localStorage,
// not sessionStorage, because the confirm-your-email link opens in a new tab, which couldn't
// see a sessionStorage value. Kept 7 days, the invite's own lifetime; cleared on use and sign-out.
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

export function getPendingInvite() {
  try {
    const saved = JSON.parse(localStorage.getItem(PENDING_INVITE_KEY) || 'null');
    if (saved?.token && Date.now() - saved.at < MAX_AGE_MS) return saved.token;
    localStorage.removeItem(PENDING_INVITE_KEY);
  } catch {}
  return null;
}

export function setPendingInvite(token) {
  try { localStorage.setItem(PENDING_INVITE_KEY, JSON.stringify({ token, at: Date.now() })); } catch {}
}

export function clearPendingInvite() {
  try { localStorage.removeItem(PENDING_INVITE_KEY); } catch {}
}

// Where to go once signed in: back to the invite if there is one
export const afterSignInPage = () => (getPendingInvite() ? '/join' : '/dashboard');
